module.exports = __webpack_public_path__ + "img/logo.b76c6195.png";